import React from 'react';
interface AssistantAvatarProps {
  size?: 'sm' | 'md' | 'lg';
}
const AssistantAvatar: React.FC<AssistantAvatarProps> = ({
  size = 'md'
}) => {
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-10 h-10',
    lg: 'w-12 h-12'
  };
  return <div className={`${sizeClasses[size]} rounded-full bg-green-50 border-2 border-green-600 flex items-center justify-center overflow-hidden`} data-id="element-224">
      <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/oDjpiHBouQ4aF9pkTrtfRi/4962a6aa-ef23-434b-add9-8772d4fb637b.png" alt="Esosa AI Assistant" className="w-full h-full object-cover" data-id="element-225" />
    </div>;
};
export default AssistantAvatar;